import { render, staticRenderFns } from "./InputSelectBranch.vue?vue&type=template&id=48ccdcbc&"
import script from "./InputSelectBranch.vue?vue&type=script&lang=ts&"
export * from "./InputSelectBranch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports